<template>
  <div v-if="$auth.check()">
    <div class="row">
      <div class="col-md-12">
        <h1>Auth v1.0</h1>
      </div>
    </div>

    <v-row>
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-text class="d-flex align-center">
            <v-avatar color="primary" size="56" class="mr-4">
              <v-icon dark large>mdi-account-group</v-icon>
            </v-avatar>
            <div>
              <div class="text-h4">
                <v-progress-circular
                  v-if="user === null"
                  indeterminate
                  size="24"
                  width="2"
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ user }}</span>
              </div>
              <div class="text-caption">Usuários</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-text class="d-flex align-center">
            <v-avatar color="primary" size="56" class="mr-4">
              <v-icon dark large>mdi-security</v-icon>
            </v-avatar>
            <div>
              <div class="text-h4">
                <v-progress-circular
                  v-if="permission === null"
                  indeterminate
                  size="24"
                  width="2"
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ permission }}</span>
              </div>
              <div class="text-caption">Permissões</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="4">
        <v-card>
          <v-card-text class="d-flex align-center">
            <v-avatar color="primary" size="56" class="mr-4">
              <v-icon dark large>mdi-application</v-icon>
            </v-avatar>
            <div>
              <div class="text-h4">
                <v-progress-circular
                  v-if="app === null"
                  indeterminate
                  size="24"
                  width="2"
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ app }}</span>
              </div>
              <div class="text-caption">Aplicações</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../api/index.js";
export default {
  data: function () {
    return {
      user: null,
      permission: null,
      app: null,
    };
  },
  created: function () {
    this.count("user");
    this.count("permission");
    this.count("app");
  },
  methods: {
    // null = carregando, "--" = falhou. Sem alert() aqui de proposito: sao tres
    // requisicoes simultaneas e tres popups empilhados seriam intragaveis.
    count: function (module) {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/" + module, { headers: { Authorization: "Bearer " + token } })
        .then(function (response) {
          me[module] = response.data.length;
        })
        .catch(function (error) {
          me[module] = "--";
          console.log(error);
        });
    },
  },
};
</script>
